// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';

import { Icon } from '@ta/styleguide.icon';
import { inputLength } from '@ta/common.string';
import classnames from '@ta/common.classnames';
import type { LinkPreviewState } from './LinkPreview';
import styles from './LinkPreviewContent.less';

type Props = {
  linkPreviewState: LinkPreviewState,
  isClickable?: boolean,
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,
  className?: string,
  matchingShelfItem?: boolean,
};

const maxTitleChar = 105;
const maxDescriptionChar = 150;

/**
 * Returns a truncated version of a passed string if it goes over a certain character limit
 * @param textBody - the string to be truncated
 * @param maxChar - the maximum number of characters allowed
 */
function truncateLinkInfo(textBody, maxChar) {
  if (inputLength(textBody) > maxChar) {
    const tempBody = textBody.substr(0, maxChar - 1).trim();
    return `${tempBody.substr(0, tempBody.lastIndexOf(' '))}...`;
  }
  return textBody;
}

/**
 * Renders a preview container that displays the URL props such as title/description/image if available
 */
const LinkPreviewContent = ({
  linkPreviewState: preview,
  isClickable,
  className,
  matchingShelfItem,
}: Props) => (
  <div
    className={classnames(styles.content, className, {
      [styles.matchingShelfItem]: matchingShelfItem,
    })}
  >
    {preview?.title?.length > 0 && (
      <p
        className={classnames('ui_link', styles.title, {
          [styles.matchingShelfItem]: matchingShelfItem,
        })}
      >
        {truncateLinkInfo(preview.title, maxTitleChar)}
      </p>
    )}
    {preview?.description?.length > 0 && !preview?.imgSource && (
      <p className={`ui_link ${styles.description}`}>
        {truncateLinkInfo(preview.description, maxDescriptionChar)}
      </p>
    )}
    <span className={styles.urlWrapper}>
      <p
        className={classnames('ui_link', styles.url, { [styles.matchingLink]: matchingShelfItem })}
      >
        {preview.urlDomain}
      </p>
      {isClickable && (
        <Icon
          name="external-link-no-box"
          className={classnames(styles.icon, { [styles.matchingLink]: matchingShelfItem })}
        />
      )}
    </span>
  </div>
);

LinkPreviewContent.defaultProps = {
  isClickable: false,
  onClick: undefined,
  className: undefined,
};

export default LinkPreviewContent;
